import { render, staticRenderFns } from "./ShippingInfo.vue?vue&type=template&id=4055ef1a&scoped=true&"
import script from "./ShippingInfo.vue?vue&type=script&lang=js&"
export * from "./ShippingInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShippingInfo.vue?vue&type=style&index=0&id=4055ef1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4055ef1a",
  null
  
)

export default component.exports